module.exports = __webpack_public_path__ + "static/media/without_elb.6b51f506.svg";